
angular.module('qkr').factory('analyticsService', ($http, appConfig) => ({
        getCoreMetrics() {
            const command = {
                metrics: [{metric: 'totalSalesValueKPI'}, {metric: 'transactionCountKPI'}, {metric: 'activeUsersKPI'}]
            };

            return $http.post(appConfig.apiUrl + 'analytics/getKPIs', command);
        },

        getCoreLoyaltyMetrics() {
            const command = {
                metrics: [{metric: 'loyaltyVsNonLoyaltyCustomerSpendPercentKPI'},
                          {metric: 'loyaltyTotalCostOfRewardsClaimedKPI'},
                          {metric: 'loyaltyUsersVsTotalUsersPercentKPI'},
                          {metric: 'loyaltyCostOfRewardsVsTotalSalesPercentKPI'},
                          {metric: 'loyaltyCustomersPerTierKPI'},
                          {metric: 'loyaltyRedemptionsPerTierKPI'}]
            };

            return $http.post(appConfig.apiUrl + 'analytics/getKPIs', command);
        },

        getChartData(chartName) {
            const command = {metric: chartName};
            return $http.post(appConfig.apiUrl + 'analytics/chartData', command);
        }
    }));




// WEBPACK FOOTER //
// ./src/services/analytics.service.js